export default __webpack_public_path__ + "static/media/decada-0070-0002-min.95ab126b.jpg";